import '../App.scss';
import { Action } from '../enums/TrackingActionType';

export function tracking(action:Action, questionId?: number, url?: string) {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const gclid = localStorage.getItem('gclid') ?? "";
    const customerDetails = JSON.parse(localStorage.getItem('customerDetails') || JSON.stringify({}));
    if (action === Action.SAVE_PURCHASE) {
        customerDetails.policyNumber = localStorage.getItem("policyRef");
    }

    const requestBody = {
        action: action,
        gclid: gclid,
        questionId: questionId,
        customerDetails: customerDetails,
        url: url !== undefined ? url : ""
    };

    fetch(`${apiBaseUrl}tracking/GoogleClickID`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json, text/plain',
            'Content-Type': 'application/json;charset=UTF-8'
        },
        body: JSON.stringify(requestBody)
    })
        .catch((error) => {
            console.error('Error: ', error);
        });
}